__turbopack_context__.v({
  "actions": "_tyYlq_actions",
  "categories": "_tyYlq_categories",
  "close": "_tyYlq_close",
  "note": "_tyYlq_note",
  "notice": "_tyYlq_notice",
  "panel": "_tyYlq_panel",
  "root": "_tyYlq_root",
  "settings": "_tyYlq_settings",
});
